//@ts-nocheck
import React, { useState, useEffect, useCallback } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Link, useParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import {
  fetchLocationListStatus,
  fetchScoreCardList,
  updateLocation,
} from "../../features/jobActions/JobActionSlice";
import DropDown from "../../components/common/DropDown";
import { ExclamationIcon, ThreeDotIcon } from "../../components/icons";
import { UserDetails } from "../job/jobType";
import { useAppDispatch } from "../../app/hooks";
import CreateJobActionCard from "./CreateJobActionCard";
import { fetchJobPipelineDetailsData } from "../../features/pipeline/pipelineSlice";

type ChannelProps = {
  userDetails: UserDetails | null;
};

interface createTeamsPayload {
  base_id: number;
  name: string;
  description: string;
  privacy: string;
  color: string;
  team_status: string;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const roleSearchList = [
  { name: "active" },
  { name: "deleted" },
  { name: "archived" },
];

const JobActionDetails: React.FC<ChannelProps> = React.memo(({}) => {
  const [searchVal, setSearchVal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBoardData, setEditBoardData] = useState<{
    id: number;
    baseId: number;
  } | null>(null);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const [selectSearchRole, setSelectSearchRole] = useState("active");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [assignUserList, setAssignUserList] = useState<
    { id: number; name: string }[]
  >([]);
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const [pipelineStageData, setPipelineStageData] = useState([]);
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

  const getStageDetails = (stageId) => {
    const scorecardData = JSON.parse(
      localStorage.getItem("jobPipelineStageData") || "{}",
    );
    console.log("scorecardData=========>", scorecardData);
    const stages = scorecardData?.stages || [];
    const stage = stages.find((stage) => stage.id === stageId);
    return stage
      ? { stage_name: stage.stage_name, stage_color: stage.stage_colour }
      : null;
  };

  // Add this useEffect to populate assignUserList from localStorage
  useEffect(() => {
    const baseMembersDetailsString = localStorage.getItem(
      "jobByHiringTeamMembers",
    );

    if (baseMembersDetailsString) {
      const baseMembersDetails = JSON.parse(baseMembersDetailsString);
      const members = userDetailsData ? JSON.parse(userDetailsData) : [];

      // Transform members to the required format
      const userList = members.map((member: any) => ({
        id: member.id,
        name: member.name,
      }));

      setAssignUserList(userList);
    }
  }, []);

  // In Teams component
  useEffect(() => {
    const teamInfoString = localStorage.getItem("jobActionData");
    if (teamInfoString) {
      const teamInfo = JSON.parse(teamInfoString);
      setBoardsFetched(teamInfo.data);
      setDataLoading(false);
    } else {
      const fetchTeams = async () => {
        setDataLoading(true);
        try {
          const baseResponse = await dispatch(
            fetchScoreCardList({
              baseId: Number(baseId),
              jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "jobActionData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setBoardsFetched([]);
        } finally {
          setDataLoading(false);
        }
      };

      if (baseId) {
        fetchTeams();
      }
    }
  }, [baseId, dispatch]);

  const handleDeleteBoard = useCallback(
    async (id: number) => {
      const payload: createTeamsPayload = {
        status: "deleted",
        id: id,
      };

      try {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            baseId,
            id: id,
          }),
        );

        if (response?.payload?.status === 200) {
          toast.success(
            response?.payload?.message ||
              "Status has been updated successfully",
          );

          const baseResponse = await dispatch(
            fetchScoreCardList({
              baseId: Number(baseId),
              jobId,
            }),
          );
          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "jobActionData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }

          setIsModalOpen(false);
          setEditBoardData(null);
        } else {
          toast.error("Failed to update status");
        }
      } catch (error) {
        toast.error("An error occurred while updating the status");
        console.error(error);
      }
    },
    [boardsFetched, dispatch],
  );

  const handleArchivedBoard = useCallback(
    async (id: number, changeStatus: string) => {
      const payload: createTeamsPayload = {
        status: changeStatus,
        id: id,
      };

      try {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            baseId,
            id: id,
          }),
        );

        if (response?.payload) {
          toast.success(
            response?.payload?.message ||
              "Status has been updated successfully",
          );

          const baseResponse = await dispatch(
            fetchScoreCardList({
              baseId: Number(baseId),
              jobId,
            }),
          );
          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "jobActionData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }

          setIsModalOpen(false);
          setEditBoardData(null);
        } else {
          toast.error("Failed to update status");
        }
      } catch (error) {
        toast.error("An error occurred while updating the status");
        console.error(error);
      }
    },
    [boardsFetched, dispatch],
  );

  // Add a new useEffect to handle updates from localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "jobActionData" && e.newValue) {
        const teamsDataArray = JSON.parse(e.newValue);
        setBoardsFetched(teamsDataArray.data || []);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleEdit = useCallback(
    (id: number, baseId: number) => {
      const teamToEdit = boardsFetched.find((team) => team.id === id);
      if (teamToEdit) {
        setEditBoardData(teamToEdit);
        setIsModalOpen(true);
      }
    },
    [boardsFetched],
  );

  const openModal = () => {
    setEditBoardData(null);
    setIsModalOpen(true);
  };

  const handleSearchRoleChange = (role: string) => {
    setSelectSearchRole(role);
  };

  const handleActive = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({
          baseId: Number(baseId),
          jobId,
          status: "active",
        }),
      );

      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem("jobActionData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete location data. Please try again later.");
    } finally {
      setLoading1(false);
    }
  };

  const handleDelete = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({
          baseId: Number(baseId),
          jobId,
          status: "deleted",
        }),
      );
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem("jobActionData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete location data. Please try again later.");
    } finally {
      setLoading1(false);
    }
  };

  const handleSuspend = async () => {
    setLoading(true);
    try {
      const res = await dispatch(
        fetchLocationListStatus({
          baseId: Number(baseId),
          jobId,
          status: "archived",
        }),
      );
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        // Update local storage
        localStorage.setItem("jobActionData", JSON.stringify(res.payload));
      } else {
        console.error("No payload received");
      }
    } catch (error) {
      console.error("Suspend failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (baseId) {
      const fetchData1 = async () => {
        const storedPipelineData = localStorage.getItem(
          "JobPipelineDetailsData",
        );

        if (storedPipelineData) {
          // const teamInfo = JSON.parse(storedBase);

          // const sortedStages = [...teamInfo?.stages].sort(
          //   (a, b) => a.order - b.order,
          // );

          let reportData = {
            stagesByBucket: {
              inbox: { name: "inbox", currentCount: 0, stages: [] },
              screening: { name: "screening", currentCount: 0, stages: [] },
              hired: { name: "hired", currentCount: 0, stages: [] },
              reject: { name: "reject", currentCount: 0, stages: [] },
            },
          };

          if (storedPipelineData) {
            const parsedPipelineData = JSON.parse(storedPipelineData);
            reportData = parsedPipelineData;
          }

          const savedData = Object.values(reportData?.stagesByBucket).flatMap(
            (bucket) => bucket.stages || [],
          );
          const sortedStages = [...savedData].sort((a, b) => a.order - b.order);
          setPipelineStageData(sortedStages);
        } else {
          try {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            if (res.status === 200) {
              localStorage.setItem(
                "jobPipelineStageData",
                JSON.stringify(res.data),
              );
            }
            const sortedStages = [...res?.data.stages].sort(
              (a, b) => a.order - b.order,
            );
            setPipelineStageData(sortedStages);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchData1();
    }
  }, [baseId, dispatch]);

  // Create a function to sort job actions by their corresponding stage order
  const getSortedBoardsFetched = useCallback(() => {
    if (!boardsFetched?.length || !pipelineStageData?.length)
      return boardsFetched;

    // Create a map of stage ID to its order for quick lookup
    const stageOrderMap = {};
    pipelineStageData.forEach((stage) => {
      stageOrderMap[stage.id] = stage.order;
    });

    // Sort the boards based on the order of their trigger_id (stage)
    return [...boardsFetched].sort((a, b) => {
      const orderA =
        stageOrderMap[a.trigger_id] !== undefined
          ? stageOrderMap[a.trigger_id]
          : Infinity;
      const orderB =
        stageOrderMap[b.trigger_id] !== undefined
          ? stageOrderMap[b.trigger_id]
          : Infinity;
      return orderA - orderB;
    });
  }, [boardsFetched, pipelineStageData]);

  const sortedBoardsFetched = getSortedBoardsFetched();

  const getUserName = (userId) => {
    // Handle case when assign_to is "0"
    if (userId === "0") {
      return [
        {
          name: "AI",
          profileImage: null,
          isAI: true,
        },
      ];
    }

    // Handle case where userId is a comma-separated string
    if (typeof userId === "string" && userId.includes(",")) {
      const userIds = userId.split(",").map((id) => id.trim());
      const users = userIds
        .map((id) => {
          // Skip "0" values in comma-separated list
          if (id === "0") {
            return {
              name: "AI",
              profileImage: null,
              isAI: true,
            };
          }
          const user = baseMembers.find(
            (member) => member.user_id === Number(id),
          );
          return user
            ? {
                name: user.name,
                profileImage: user.profile_pic || null,
                isAI: false,
              }
            : null;
        })
        .filter((user) => user !== null);

      return users?.length > 0 ? users : null;
    }

    // Handle single user case (original functionality)
    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    if (!user) return null;

    return [
      {
        name: user.name,
        profileImage: user.profile_pic || null,
        isAI: false,
      },
    ];
  };

const darkenHex = (hex, percent) => {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  r = Math.floor(r * (1 - percent));
  g = Math.floor(g * (1 - percent));
  b = Math.floor(b * (1 - percent));

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

  return (
    <>
      <Toaster richColors />
      <div className="h-full">
        <main className="py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex">
          <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
            <div className="w-full max-w-[640px]">
              <div className="flex flex-col gap-y-1 w-full">
                <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                  Automated Actions
                </h2>
                <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                  Create rules to automate your workflow. Choose an event, like
                  a stage change, and set a corresponding action to run
                  automatically.
                </p>
              </div>
              <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>

              <div className=" mt-6 lg:mt-8 flex items-center  w-full gap-x-3">
                <div className="w-full lg:w-[40%]">
                  <div className="mt-[0px]">
                    <input
                      type="text"
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      name="search"
                      id="search"
                      placeholder="Search type"
                      className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                      focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                      border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                    />
                  </div>
                </div>

                <div className="w-full lg:w-[20%]">
                  <div className="mt-[0px]">
                    <DropDown
                      onChangeValue={handleSearchRoleChange}
                      data={roleSearchList}
                      previousValue={selectSearchRole}
                      onDelete={handleDelete}
                      onArchived={handleSuspend}
                      onActive={handleActive}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-[40%]">
                  <div className="mt-[0px] flex justify-end">
                    <button
                      onClick={openModal}
                      type="button"
                      className="inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Create Actions
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-6 w-full">
                {dataLoading ? (
                  <div
                    className="flex items-center justify-center relative z-50"
                    style={{ height: "calc(100vh - 191px)" }}
                  >
                    <div className="simple-spinner-loader">
                      <span></span>
                    </div>
                  </div>
                ) : sortedBoardsFetched?.length === 0 ? (
                  <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
                    <ExclamationIcon />
                    <p className="text-[#0000007a] text-[13px]">
                      No results found
                    </p>
                  </div>
                ) : (
                  <>
                    {sortedBoardsFetched
                      ?.filter((post) => {
                        if (searchVal === "") {
                          return post;
                        } else if (
                          post?.action_type
                            ?.toLowerCase()
                            .includes(searchVal.toLowerCase())
                          // ||
                          // post?.scorecard_description?.toLowerCase().includes(searchVal.toLowerCase())
                        ) {
                          return post;
                        }
                      })
                      .map((items: any, index: number) => {
                        const stageDetails = items.trigger_id
                          ? getStageDetails(items.trigger_id)
                          : null;

                        const rawMemberDetails = getUserName(items.assign_to);
                        const memberDetails = Array.isArray(rawMemberDetails)
                          ? rawMemberDetails
                          : rawMemberDetails
                            ? [rawMemberDetails]
                            : [];

                        return (
                          <div key={index} className="w-full flex">
                            <ul className="list-none w-full">
                              <li className="flex flex-row items-start justify-between text-[0.875rem] w-full rounded-[0.375rem] bg-white border border-solid border-[#E3E3E7] mb-5 py-4 px-4">
                                <div className="flex flex-col w-full gap-y-1">
                                  

                                  <div className="flex flex-col w-full gap-y-1">
                                    <div className="flex gap-3 items-center">
                                  
                                    {stageDetails && (
                                    <span
  className="inline-flex w-fit items-center rounded-md px-2 py-1 text-xs font-normal capitalize border border-solid"
  style={{
    backgroundColor: `${stageDetails.stage_color}10`,
    // Pass 0.3 to make it 30% darker
    color: darkenHex(stageDetails.stage_color, 0.3), 
    borderColor: stageDetails.stage_color,
  }}
>
  {stageDetails.stage_name}
</span>
                                  )}
                                    {items?.action_type && (
                                      <span className="text-[0.8125rem] font-medium leading-5 text-[#1b1b1b] block capitalize">
                                        {items?.action_type}
                                      </span>
                                    )}
                                  </div>
                                    {items?.action_name && (
                                      <span className="text-[0.8125rem] font-normal leading-4 text-[#5c5c5e] block">
                                        {items?.action_name}
                                      </span>
                                    )}
                                  </div>
                                  {memberDetails?.length > 0 && (
                                    <div className="bg-[#e0e0e0] w-full h-[1px] my-[6px]"></div>
                                  )}

                                  <div className="flex items-center gap-x-3">
                                    {memberDetails?.length > 0 && (
                                      <span className="text-[0.8125rem] font-normal leading-4 text-[#5c5c5e]">
                                        {" "}
                                        Assign Users:{" "}
                                      </span>
                                    )}

                                    {/* memberDetails */}

                                    {memberDetails?.length > 0 &&
                                      memberDetails.map((item, index) => {
                                        return (
                                          <div
                                            key={index}
                                            className="flex flex-row items-center gap-x-2"
                                          >
                                            {item.isAI ? (
                                              // Show AI icon
                                              <div className="h-5 w-5 rounded-full bg-gray-100 p-1 flex items-center justify-center text-xs text-gray-600">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  fill="none"
                                                  viewBox="0 0 24 24"
                                                  strokeWidth="1.5"
                                                  stroke="currentColor"
                                                  aria-hidden="true"
                                                  data-slot="icon"
                                                  className="w-[0.8rem] h-[0.8rem] text-[#808080] "
                                                >
                                                  <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                                                  />
                                                </svg>
                                              </div>
                                            ) : item.profileImage ? (
                                              <img
                                                src={`${process.env.REACT_APP_API_BASE_URL}/${item.profileImage}`}
                                                alt={item.name}
                                                className="h-5 w-5 rounded-full object-cover"
                                              />
                                            ) : (
                                              <div className="h-5 w-5 rounded-full bg-gray-100 flex items-center justify-center text-xs text-gray-600">
                                                {item.name
                                                  .charAt(0)
                                                  .toUpperCase()}
                                              </div>
                                            )}
                                            <div className="flex flex-col">
                                              <span className="text-[0.8125rem] font-medium leading-5 text-[#1b1b1b]">
                                                {item.name}
                                              </span>
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                </div>
                                <div className="px-0 flex items-center">
                                  {items.runs && (
                                    <span className="inline-flex mb-1 w-fit items-center rounded-md px-2 py-1 text-xs font-medium bg-gray-50 text-gray-600 ring-gray-500/10 capitalize ring-1 ring-inset ">
                                      {items.runs}
                                    </span>
                                  )}
                                  <Menu
                                    as="div"
                                    className="relative inline-block text-left"
                                  >
                                    <div>
                                      <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                        <span className="sr-only">
                                          Open options
                                        </span>
                                        <ThreeDotIcon />
                                      </MenuButton>
                                    </div>

                                    <Transition
                                      enter="transition ease-out duration-100"
                                      enterFrom="transform opacity-0 scale-95"
                                      enterTo="transform opacity-100 scale-100"
                                      leave="transition ease-in duration-75"
                                      leaveFrom="transform opacity-100 scale-100"
                                      leaveTo="transform opacity-0 scale-95"
                                    >
                                      <MenuItems className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div className="py-1">
                                          <MenuItem>
                                            {({ focus }) => (
                                              <div
                                                onClick={() =>
                                                  handleEdit(
                                                    items.id,
                                                    items.base_id,
                                                  )
                                                }
                                                className={classNames(
                                                  focus
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "block px-4 py-2 text-sm",
                                                )}
                                              >
                                                Edit
                                              </div>
                                            )}
                                          </MenuItem>
                                          <MenuItem>
                                            {({ focus }) => (
                                              <Link
                                                to="#"
                                                className={classNames(
                                                  focus
                                                    ? "bg-gray-100 text-gray-900"
                                                    : "text-gray-700",
                                                  "block px-4 py-2 text-sm",
                                                )}
                                                onClick={() =>
                                                  handleDeleteBoard(
                                                    items.id,
                                                    items.base_id,
                                                  )
                                                }
                                              >
                                                Delete
                                              </Link>
                                            )}
                                          </MenuItem>
                                          {selectSearchRole === "active" && (
                                            <MenuItem>
                                              {({ focus }) => (
                                                <Link
                                                  to="#"
                                                  onClick={() =>
                                                    handleArchivedBoard(
                                                      items.id,
                                                      "archived",
                                                    )
                                                  }
                                                  className={classNames(
                                                    focus
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "block px-4 py-2 text-sm",
                                                  )}
                                                >
                                                  Archived
                                                </Link>
                                              )}
                                            </MenuItem>
                                          )}
                                          {selectSearchRole === "archived" && (
                                            <MenuItem>
                                              {({ focus }) => (
                                                <Link
                                                  to="#"
                                                  onClick={() =>
                                                    handleArchivedBoard(
                                                      items.id,
                                                      "active",
                                                    )
                                                  }
                                                  className={classNames(
                                                    focus
                                                      ? "bg-gray-100 text-gray-900"
                                                      : "text-gray-700",
                                                    "block px-4 py-2 text-sm",
                                                  )}
                                                >
                                                  Active
                                                </Link>
                                              )}
                                            </MenuItem>
                                          )}
                                        </div>
                                      </MenuItems>
                                    </Transition>
                                  </Menu>
                                </div>
                              </li>
                            </ul>
                          </div>
                        );
                      })}
                  </>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      <CreateJobActionCard
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        editBoardData={editBoardData}
        baseId={baseId}
        setEditBoardData={setEditBoardData}
        pipelineStageData={pipelineStageData}
        setPipelineStageData={setPipelineStageData}
        setBoardsFetched={setBoardsFetched}
      />
    </>
  );
});
export default JobActionDetails;
